import { UtenteDTO } from "./utenteDTO";
import { TipoVisibilitaEnum } from "../enum/tipo-visibilita-enum";

export class VisibilitaFascicoloDTO {
    dataInizioVisibilita: string;
    dataFineVisibilita: string;
    operatore: UtenteDTO;
    utente: UtenteDTO;
    tipoVisibilita: TipoVisibilitaEnum;
}